import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_ADDRESS,
} from './constants';

import {
  GET_VALIDATE_SUCCESS,
} from '../../FastCover/constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    paymentTo: '',
    paymentVia: '',
    title: '',
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    country: null,
    state: '',
    city: '',
    postalZipCode: '',
    mobile: '',
    // new bank details
    bankTypeCode: '',
    bankCodeOrRoutingNumber: '',
    isValidate: false,
    isVerified: false,
    bank: '',
    bankAddress: '',
    bankSuburbOrCity: '',
    bankPostcode: '',
    bankBranch: '',
    bankAccountName: '',
    bankAccountNumber: '',
    swiftCode: '',
    iban: '',
    paymentTypeOptions: [],
    reValidateForm: false,
    //----------------
  },
  errors: [],
});

const initialAddress = {
  form: {
    addressLine1: '',
    addressLine2: '',
    firstName: '',
    mobile: '',
    lastName: '',
    title: '',
    state: '',
    country: null,
    postalZipCode: '',
    city: '',
  },
};

function jira_ta1734_invalidateCountryField(formData){
  if(!formData.country){
    return formData;
  }
  const isNumeric = (num) => (typeof(num) === 'number' || typeof(num) === "string" && num.trim() !== '') && !isNaN(num);
  if(!isNumeric(formData.country)){
    formData.country = '';
  }
  return formData;
}

function stepPaymentDetailsReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      if (action.payload) {

        return fromJS({
          // form: jira_ta1734_invalidateCountryField(action.payload),
          form: action.payload,
          errors: [],
        });
      }
      return initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_ADDRESS:
      return state.mergeDeep(initialAddress);
    case GET_VALIDATE_SUCCESS:
      return state.mergeDeep({ form: action.bankInfo });
    default:
      return state;
  }
}

export default stepPaymentDetailsReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPaymentDetails/reducer.js